/* Kairos / Mirage — PaySelect dönüş ve sepet yaşam döngüsü düzeltmesi.
 * assets/cart-drawer.js dosyasının TAMAMI yerine kullanılır.
 * Ödeme tercihini veya indirim tutarını değiştirmez; bunları PaySelect yönetir.
 */
(() => {
  'use strict';

  const sectionsToRender = [
    { id: '#cart-counter', section: 'cart-counter', selector: '#shopify-section-cart-counter' },
    { id: '#CartDrawer-Body', section: 'cart-drawer', selector: '#shopify-section-cart-drawer #CartDrawer-Body' }
  ];

  if (!customElements.get('cart-drawer')) {
    class CartDrawer extends HTMLElement {
      constructor() {
        super();
        this.onKeyUp = event => {
          if (event.key === 'Escape' || event.code === 'Escape') this.close();
        };
        this.onOverlayClick = () => this.close();
        this.onCartClick = event => {
          event.preventDefault();
          this.open(event.currentTarget);
        };
        this.onCartKeyDown = event => {
          if (event.code === 'Space') {
            event.preventDefault();
            this.open(event.currentTarget);
          }
        };
        this.onSectionSelect = () => this.open();
        this.onSectionDeselect = () => this.close();
        // Checkout'a giderken açık çekmecenin iOS dokunma/kaydırma kilidini bırak.
        this.onPageHide = () => this.close(false);
        this.onPageShow = event => {
          if (event.persisted) this.close(false);
        };
      }

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('keyup', this.onKeyUp);
        this.overlay = this.querySelector('#CartDrawer-Overlay');
        this.overlay?.addEventListener('click', this.onOverlayClick);
        this.sectionWrapper = this.parentElement;
        this.sectionWrapper?.addEventListener('shopify:section:select', this.onSectionSelect);
        this.sectionWrapper?.addEventListener('shopify:section:deselect', this.onSectionDeselect);
        window.addEventListener('pagehide', this.onPageHide);
        window.addEventListener('pageshow', this.onPageShow);
        this.setCartLink();
      }

      disconnectedCallback() {
        // PaySelect bölüm HTML'ini değiştirdiğinde eski çekmece burada temizlenir.
        this.close(false);
        this.removeEventListener('keyup', this.onKeyUp);
        this.overlay?.removeEventListener('click', this.onOverlayClick);
        this.sectionWrapper?.removeEventListener('shopify:section:select', this.onSectionSelect);
        this.sectionWrapper?.removeEventListener('shopify:section:deselect', this.onSectionDeselect);
        window.removeEventListener('pagehide', this.onPageHide);
        window.removeEventListener('pageshow', this.onPageShow);
        this.unbindCartLink();
        this.initialized = false;
      }

      unbindCartLink() {
        this.cartLink?.removeEventListener('click', this.onCartClick);
        this.cartLink?.removeEventListener('keydown', this.onCartKeyDown);
        this.cartLink = null;
      }

      setCartLink() {
        this.unbindCartLink();
        this.cartLink = document.querySelector('[data-cart-link]');
        if (!this.cartLink) return;
        this.cartLink.setAttribute('role', 'button');
        this.cartLink.setAttribute('aria-haspopup', 'dialog');
        this.cartLink.addEventListener('click', this.onCartClick);
        this.cartLink.addEventListener('keydown', this.onCartKeyDown);
      }

      currentDrawer() {
        return this.isConnected ? this : document.querySelector('cart-drawer');
      }

      open(opener) {
        // Ürün formu eski sepet nesnesini tutsa bile güncel çekmeceyi kullan.
        const current = this.currentDrawer();
        if (current !== this) return current?.open(opener);
        if (!this.isConnected) return;
        const dialog = this.querySelector('[role="dialog"]');
        if (!dialog) return;
        if (opener) this.setActiveElement(opener);
        else if (!this.classList.contains('is-visible')) this.setActiveElement(document.activeElement);
        this.classList.add('is-visible');
        if (!this.lockedDialog) {
          bodyScroll.lock(dialog);
          this.lockedDialog = dialog;
        }
        cancelAnimationFrame(this.focusFrame);
        this.focusFrame = requestAnimationFrame(() => this.focusOnCartDrawer());
      }

      close(restoreFocus = true) {
        cancelAnimationFrame(this.focusFrame);
        this.classList.remove('is-visible');
        if (this.hasFocusTrap) {
          const opener = restoreFocus && this.activeElement?.isConnected ? this.activeElement : null;
          removeTrapFocus(opener);
          this.hasFocusTrap = false;
        }
        if (this.lockedDialog) {
          // Sadece bu çekmecenin kilidi kaldırılır; diğer modal kilitleri korunur.
          bodyScroll.unlock(this.lockedDialog);
          this.lockedDialog = null;
        }
      }

      setActiveElement(element) {
        this.activeElement = element;
      }

      focusOnCartDrawer() {
        if (!this.isConnected || !this.classList.contains('is-visible')) return;
        const container = this.firstElementChild;
        const focusElement = this.querySelector('[data-drawer-close]');
        if (!container || !focusElement) return;
        trapFocus(container, focusElement);
        this.hasFocusTrap = true;
      }

      renderContents(response, open = true) {
        const current = this.currentDrawer();
        if (current !== this) return current?.renderContents(response, open);
        if (!this.isConnected) return;

        // Tüm parçaları doğruladıktan sonra mevcut tema hedeflerine yerleştir.
        const updates = this.getSectionsToRender().map(section => {
          const target = document.querySelector(section.id);
          const html = response.sections?.[section.section];
          if (!target || typeof html !== 'string') throw new Error('Sepet bölümü yüklenemedi: ' + section.section);
          return { target, html: this.getSectionInnerHTML(html, section.selector) };
        });
        updates.forEach(update => { update.target.innerHTML = update.html; });
        this.setCartLink();
        if (open) this.open();
      }

      getSectionsToRender() {
        return sectionsToRender;
      }

      getSectionInnerHTML(html, selector) {
        const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
        if (!element) throw new Error('Sepet HTML hedefi bulunamadı: ' + selector);
        return element.innerHTML;
      }
    }
    customElements.define('cart-drawer', CartDrawer);
  }

  if (!customElements.get('cart-drawer-items')) {
    class CartDrawerItems extends CartItems {
      getSectionsToRender() {
        return sectionsToRender;
      }
    }
    customElements.define('cart-drawer-items', CartDrawerItems);
  }
})();
